var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIcoCapaFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 500,
    height: 500,
    viewBox: "0 0 500 500",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M49 168.521V361.79C49 368.722 52.5898 375.16 58.4872 378.804L216.719 476.573C223.381 480.69 231.975 475.898 231.975 468.066V272.654C231.975 265.651 228.313 259.159 222.32 255.537L64.1722 159.963C57.5076 155.935 49 160.734 49 168.521Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M451.645 168.025V361.294C451.645 368.226 448.055 374.664 442.157 378.308L283.926 476.077C277.264 480.194 268.669 475.402 268.669 467.57V272.158C268.669 265.155 272.332 258.663 278.325 255.041L436.472 159.467C443.137 155.439 451.645 160.238 451.645 168.025Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M239.022 12.2687L79.8479 109.064C73.457 112.95 73.4388 122.22 79.8143 126.132L238.955 223.767C245.328 227.677 253.35 227.706 259.751 223.841L421.534 126.169C427.991 122.271 427.973 112.9 421.5 109.027L259.683 12.1952C253.316 8.38487 245.362 8.41316 239.022 12.2687Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCapaFill);
export default __webpack_public_path__ + "static/media/ico_capa_fill.f8e8402a3c4bbb577f80159c08952102.svg";
export { ForwardRef as ReactComponent };